// extracted by mini-css-extract-plugin
module.exports = {"env-vars":"environment_variables_editor__env-vars___N4SOL","envVars":"environment_variables_editor__env-vars___N4SOL"};